class QuickAddButton extends ModalOpener {
    constructor() {
        super();
        this.productHandle = this.getAttribute('data-handle');
        this.submitType = this.getAttribute('data-submit');
        this.modalContent = this.modal.querySelector('.base-modal__content');
        this.addEventListener('click', this.openDrawer.bind(this));
    }

    openDrawer(e) {
        e.preventDefault();
        e.stopPropagation();

        if (this.submitType == 'show-options') {
            this.classList.add('modal-is-open');

            const clickedButton = e.target.closest('button');
            if (clickedButton) {
                clickedButton.classList.add('loading');
                clickedButton.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
            }

            var link = '/products/' + this.productHandle;
            fetch(link)
                .then(res => res.text())
                .then(html => {
                    var parser = new DOMParser();

                    var productElement = parser.parseFromString(html, "text/html");
                    if (productElement == null) {
                        return 0;
                    }
                    var productContent = productElement.querySelector('.shopify-section.product-section');
                    if (productContent.querySelector('.sticky-addtocart-wrapper')) productContent.querySelector('.sticky-addtocart-wrapper').remove();

                    HTMLUpdateUtility.setInnerHTML(this.modalContent, productContent.outerHTML);

                    if (typeof loadingImages === 'function') {
                        loadingImages(this.modalContent);
                    }

                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                    if (window.ProductModel) window.ProductModel.loadShopifyXR();

                    // The injected section brings its own stylesheets, which load
                    // asynchronously. On a first open they aren't cached yet, so
                    // showing the drawer right away flashes unstyled content.
                    // Wait for them (capped so a slow file can't block the drawer).
                    return this.waitForStylesheets(this.modalContent).then(() => {
                        if (clickedButton) {
                            clickedButton.classList.remove('loading');
                            clickedButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
                        }

                        if (this.modal && this.modal.show) {
                            this.modal.show(this.buttonOpener);
                        }

                    const quickOptionElement = document.getElementById('product-quick-add-dialog');
                    if (quickOptionElement) {
                        const variantsPicker = quickOptionElement.querySelectorAll('variant-radios, variant-selects');
                        variantsPicker.forEach(element => {
                            element.setAttribute('data-update-url', 'false');
                        });
                    }

                        this.initQuickAddMediaNav();
                        this.initQuickAddSlider();
                        this.initQuickAddStickyAtc();
                    });
                });
        } else {
            this.directAddToCart(e);
        }
    }

    waitForStylesheets(root, timeout = 2000) {
        const pending = Array.from(root.querySelectorAll('link[rel="stylesheet"]'))
            .filter((link) => !link.sheet)
            .map((link) => new Promise((resolve) => {
                link.addEventListener('load', resolve, { once: true });
                link.addEventListener('error', resolve, { once: true });
            }));
        if (pending.length === 0) return Promise.resolve();
        return Promise.race([
            Promise.all(pending),
            new Promise((resolve) => setTimeout(resolve, timeout))
        ]);
    }

    // Direct add to cart (single-variant products). Adds via the AJAX cart API
    // and opens the cart drawer, mirroring ProductForm.onSubmitHandler, instead
    // of a native form submit (which showed no spinner and redirected to /cart).
    // Falls back to the cart page only when no drawer/notification exists
    // (i.e. cart type is "Page").
    directAddToCart(e) {
        const container = e.target.closest('.product-card-information');
        const formAddToCart = container ? container.querySelector('.form-add-to-cart') : null;
        if (!formAddToCart) return;

        const clickedButton = e.target.closest('button');
        if (clickedButton) {
            if (clickedButton.classList.contains('loading')) return;
            clickedButton.classList.add('loading');
            clickedButton.setAttribute('aria-disabled', true);
            clickedButton.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
        }

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(formAddToCart);
        if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) return;
                if (!cart) {
                    window.location = window.routes.cart_url;
                    return;
                }
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'quick-add-button',
                        productVariantId: formData.get('id'),
                        cartData: response,
                    });
                }
                cart.renderContents(response);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                if (clickedButton) {
                    clickedButton.classList.remove('loading');
                    clickedButton.removeAttribute('aria-disabled');
                    clickedButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
                }
                if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            });
    }

    showLoading(button) {
        button.classList.add('is-loading');
        const spinner = document.createElement('span');
        spinner.className = 'quick-add-spinner';
        button.appendChild(spinner);
    }

    hideLoading(button) {
        button.classList.remove('is-loading');
        const spinner = button.querySelector('.quick-add-spinner');
        if (spinner) spinner.remove();
    }

    initQuickAddMediaNav() {
        const container = this.modalContent.querySelector('.product-image-on-quick-add');
        if (!container) return;
        if (container.querySelector('slider-component.quick-add-media-slider')) return;

        const items = container.querySelectorAll('.quick-add-media-item');
        const prevBtn = container.querySelector('.quick-add-media-nav__btn--prev');
        const nextBtn = container.querySelector('.quick-add-media-nav__btn--next');

        if (!prevBtn || !nextBtn || items.length <= 1) return;

        const navigate = (direction) => {
            const current = container.querySelector('.quick-add-media-item:not(.hidden)');
            if (!current) return;

            const currentIndex = parseInt(current.dataset.quickAddMediaIndex);
            let nextIndex;

            if (direction === 'next') {
                nextIndex = currentIndex + 1 >= items.length ? 0 : currentIndex + 1;
            } else {
                nextIndex = currentIndex - 1 < 0 ? items.length - 1 : currentIndex - 1;
            }

            window.pauseAllMedia();

            current.classList.add('quick-add-fade-out');
            setTimeout(() => {
                current.classList.add('hidden');
                current.classList.remove('quick-add-fade-out');

                const nextItem = container.querySelector(`[data-quick-add-media-index="${nextIndex}"]`);
                if (nextItem) nextItem.classList.remove('hidden');
            }, 300);
        };

        prevBtn.addEventListener('click', () => navigate('prev'));
        nextBtn.addEventListener('click', () => navigate('next'));

        prevBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('prev');
            }
        });

        nextBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('next');
            }
        });
    }

    initQuickAddSlider() {
        const slider = this.modalContent.querySelector('slider-component.quick-add-media-slider');
        if (!slider) return;
        const list = slider.querySelector('[id^="Slider-QuickAdd"]');
        const page = list ? parseInt(list.getAttribute('data-page') || '1', 10) : 1;
        if (typeof slider.initPages === 'function') slider.initPages();
        if (page > 1 && typeof slider.goToSlide === 'function') {
            setTimeout(() => {
                slider.currentPage = page;
                slider.goToSlide();
            }, 550);
        }

        const step = (dir) => {
            const total = typeof slider.getTotalPages === 'function' ? slider.getTotalPages() : 1;
            const next = Math.min(Math.max(1, (slider.currentPage || 1) + dir), total);
            if (next === slider.currentPage) return;
            slider.currentPage = next;
            if (typeof slider.goToSlide === 'function') slider.goToSlide();
        };

        const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (list && finePointer) {
            let wheelAcc = 0, wheelLock = 0;
            list.addEventListener('wheel', (e) => {
                const dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
                if (!dx) return;
                e.preventDefault();
                const now = Date.now();
                if (now < wheelLock) return;
                wheelAcc += dx;
                if (Math.abs(wheelAcc) >= 40) { step(wheelAcc > 0 ? 1 : -1); wheelAcc = 0; wheelLock = now + 400; }
            }, { passive: false });

            let dragStartX = null, dragged = false;
            list.addEventListener('pointerdown', (e) => {
                if (e.pointerType !== 'mouse' || e.button !== 0) return;
                dragStartX = e.clientX; dragged = false;
                list.setPointerCapture(e.pointerId);
            });
            list.addEventListener('pointermove', (e) => {
                if (dragStartX === null) return;
                if (Math.abs(e.clientX - dragStartX) > 8 && !dragged) { dragged = true; list.classList.add('is-dragging'); }
            });
            const endDrag = (e) => {
                if (dragStartX === null) return;
                const dx = e.clientX - dragStartX;
                dragStartX = null;
                list.classList.remove('is-dragging');
                if (Math.abs(dx) >= 40) step(dx < 0 ? 1 : -1);
            };
            list.addEventListener('pointerup', endDrag);
            list.addEventListener('pointercancel', endDrag);
            list.addEventListener('click', (e) => { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
            list.addEventListener('dragstart', (e) => e.preventDefault());
        }

        const current = slider.querySelector('.slider-counter--current');
        const total = slider.querySelector('.slider-counter--total');
        const syncCounter = () => {
            if (total && typeof slider.getTotalPages === 'function') total.textContent = slider.getTotalPages();
            if (current) current.textContent = slider.currentPage || 1;
        };
        slider.addEventListener('slideChanged', syncCounter);
        requestAnimationFrame(syncCounter);
    }

    initQuickAddStickyAtc() {
        const dialog = document.getElementById('product-quick-add-dialog');
        if (!dialog) return;

        if (!dialog._qaStickyHideHooked) {
            dialog._qaStickyHideHooked = true;
            const origHide = dialog.hide.bind(dialog);
            dialog.hide = () => { if (dialog._qaStickyCleanup) { dialog._qaStickyCleanup(); dialog._qaStickyCleanup = null; } origHide(); };
        }

        const inner = dialog.querySelector('.base-modal__inner');
        const scroller = dialog.querySelector('.base-modal__content');

        if (dialog._qaStickyCleanup) { dialog._qaStickyCleanup(); dialog._qaStickyCleanup = null; }
        if (inner) inner.querySelectorAll(':scope > [data-quick-add-sticky-atc]').forEach((el) => el.remove());

        const bar = this.modalContent.querySelector('[data-quick-add-sticky-atc]');
        if (!bar || !inner || !scroller) return;

        const form = this.modalContent.querySelector('form[data-type="add-to-cart-form"]');
        const original = this.modalContent.querySelector('.product-form__submit');
        if (!form || !original) return;

        inner.appendChild(bar);
        bar.removeAttribute('hidden');
        dialog.style.setProperty('--qa-sticky-h', bar.offsetHeight + 'px');

        const barBtn = bar.querySelector('.quick-add-sticky-atc__button');
        const barLabel = bar.querySelector('.quick-add-sticky-atc__label');

        const onClick = () => {
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.submit();
        };
        barBtn.addEventListener('click', onClick);

        let outOfView = false;
        const canBuy = () =>
            !original.disabled &&
            !original.classList.contains('disabled') &&
            !original.classList.contains('hidden');
        const apply = () => {
            bar.classList.toggle('is-visible', outOfView && canBuy());
        };

        const io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => { outOfView = !entry.isIntersecting; });
            apply();
        }, { root: scroller, threshold: 0 });
        io.observe(original);

        const mirror = () => {
            barBtn.disabled = original.disabled;
            barBtn.classList.toggle('loading', original.classList.contains('loading'));
            const origContent = original.querySelector('span');
            if (origContent && barLabel) barLabel.innerHTML = origContent.innerHTML;
            apply();
        };
        mirror();
        const mo = new MutationObserver(mirror);
        mo.observe(original, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true, characterData: true });

        dialog._qaStickyCleanup = () => {
            io.disconnect();
            mo.disconnect();
            barBtn.removeEventListener('click', onClick);
            if (bar.parentNode) bar.parentNode.removeChild(bar);
            dialog.style.removeProperty('--qa-sticky-h');
        };
    }
}

if (!customElements.get('quick-add-button')) customElements.define('quick-add-button', QuickAddButton);